import {Nachfolgeartikel} from './nachfolgeartikel';
import {Verfuegbarkeitsinformation} from './verfuegbarkeitsinformation';

export class ArtikelVerfuegbarkeit {
  Nachfolgeartikel: Nachfolgeartikel;
  Verfuegbarkeitsinformation: Verfuegbarkeitsinformation[];
}
